var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset28(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.69 123.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ede20f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #dbdb45;\n      }\n\n      .cls-3 {\n        fill: #333;\n      }\n\n      .cls-4 {\n        fill: #5b5b14;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.52,
    width: 100.39,
    height: 100.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.1,36.52c-3.01,0-5.47-2.29-5.47-5.11s2.45-5.11,5.47-5.11,5.46,2.29,5.46,5.11-2.45,5.11-5.46,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.1,26.42c2.94,0,5.34,2.24,5.34,4.99s-2.4,4.99-5.34,4.99-5.34-2.24-5.34-4.99,2.4-4.99,5.34-4.99M142.1,26.17c-3.09,0-5.59,2.35-5.59,5.24s2.5,5.24,5.59,5.24,5.59-2.35,5.59-5.24-2.5-5.24-5.59-5.24h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.98,44.83v68.64H10.46v-13.46H.56v23.35h146.32V44.83h-9.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.59,91.69c-3.01,0-5.46-2.29-5.46-5.11s2.45-5.11,5.46-5.11,5.46,2.29,5.46,5.11-2.45,5.11-5.46,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.59,81.59c2.94,0,5.34,2.24,5.34,4.99s-2.4,4.99-5.34,4.99-5.34-2.24-5.34-4.99,2.4-4.99,5.34-4.99M5.59,81.34c-3.09,0-5.59,2.35-5.59,5.24s2.5,5.24,5.59,5.24,5.59-2.35,5.59-5.24-2.5-5.24-5.59-5.24h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.32,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.61,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.89,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.18,
    cy: 88.41,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 37.32,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.61,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.18,
    cy: 62.43,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.61,
    cy: 36.45,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 110.18,
    cy: 36.45,
    rx: 5.59,
    ry: 5.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 61.61,
    cy: 10.47,
    rx: 5.59,
    ry: 5.24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset28);
export default __webpack_public_path__ + "static/media/Asset 28.f7fdbdda6e61a3e5240a2232905c9a6e.svg";
export { ForwardRef as ReactComponent };